<template>
  <div class="logout">
    
  </div>
</template>

<script>
export default {
  name: 'Logout',
  mounted() {
    localStorage.token = ''
    localStorage.user = ''
    localStorage.daily = ''

    this.$router.push({
      name: 'Login'
    })
  }
}
</script>
